import { View } from 'react-native';
import { WordSquare } from './index';
import { styles } from './styles';

export function WordSquareContainer({ word, correctWords }) {
  return (
    <View style={styles.outerContainer}>
      <View style={styles.innerContainer}>
        <WordSquare word={word} correctWords={correctWords} />
      </View>
    </View>
  );
}
